import { Navigate } from "react-router-dom";

// import { useQueryParams } from "../hooks/query";

const RedirectPage = () => {
  // const params = useQueryParams();
  return <Navigate to="/" replace />;
};

export default RedirectPage;
